import styled from 'styled-components'
import {palette} from 'styled-tools'

const Label = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 500;
  color: ${palette('blue')};
  padding-bottom: 8px;
`

export default Label
